import { render, staticRenderFns } from "./NewFormsWidget.vue?vue&type=template&id=6186cf5c&scoped=true"
import script from "./NewFormsWidget.vue?vue&type=script&lang=js"
export * from "./NewFormsWidget.vue?vue&type=script&lang=js"
import style0 from "./NewFormsWidget.vue?vue&type=style&index=0&id=6186cf5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6186cf5c",
  null
  
)

export default component.exports